export async function encodeParamsHmacBase64 (data, secret) {
  // 1. Canonicalize object
  // 1. Sort and build "key=value,key2=value2" string
  const canonical = Object.entries(data)
    .filter(([, v]) => v !== undefined && v !== null)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([k, v]) => `${k}=${String(v)}`)
    .join(",");

  // 2. Encode with UTF-8
  const enc = new TextEncoder();
  const msgBytes = enc.encode(canonical);
  const keyBytes = enc.encode(secret);

  // 3. Create HMAC-SHA256 signature
  const key = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );
  const signature = await crypto.subtle.sign("HMAC", key, msgBytes);

  // 4. Convert ArrayBuffer → Base64
  const bytes = new Uint8Array(signature);
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}
